import React from 'react';
import Feature from '../feature/Feature';
import { Icons } from '../../../../assets/icons';
import type { paths } from '../../../../endpoint/Schema';
import { InputNumber } from 'primereact/inputnumber';

interface ReferralFeatureProps {
  featureSettings:
    | paths['/api/v2/admin/feature-setting']['get']['responses']['200']['content']['application/json']
    | undefined;
  setFeatureSettings: React.Dispatch<
    React.SetStateAction<
      | paths['/api/v2/admin/feature-setting']['get']['responses']['200']['content']['application/json']
      | undefined
    >
  >;
}

function ReferralFeature({
  featureSettings,
  setFeatureSettings,
}: ReferralFeatureProps) {
  const handleReferralChecked = (checked: boolean) => {
    setFeatureSettings((prev) => ({
      ...prev,
      referralSettings: {
        ...prev?.referralSettings,
        enabled: checked,
        maximumMemberWithReferralCode:
          prev?.referralSettings?.maximumMemberWithReferralCode ?? 5,
      },
    }));
  };

  const handleMaxMembersChange = (value: number | null) => {
    setFeatureSettings((prev) => ({
      ...prev,
      referralSettings: {
        ...prev?.referralSettings,
        maximumMemberWithReferralCode: value ?? 5,
      },
    }));
  };

  return (
    <Feature
      icon={Icons.ic_referral}
      image="img_reward" // Using reward image as placeholder
      title="Referrals"
      description="Enable the referral system to allow users to invite friends and family to join your service. Set limits on how many people can use each referral code."
      checked={featureSettings?.referralSettings?.enabled ?? false}
      onChange={handleReferralChecked}
    >
      {featureSettings?.referralSettings?.enabled && (
        <div className="mt-5 mb-6 flex flex-col gap-4">
          <div className="flex items-center gap-3">
            <label className="text-sm font-medium text-gray-700 min-w-[180px]">
              Max users per referral code:
            </label>
            <InputNumber
              value={
                featureSettings?.referralSettings
                  ?.maximumMemberWithReferralCode ?? 5
              }
              onValueChange={(e) => {
                handleMaxMembersChange(e.value ?? null);
              }}
              min={1}
              max={100}
              showButtons
              buttonLayout="horizontal"
              className="w-32"
            />
          </div>
          <p className="text-xs text-gray-500 ml-[192px]">
            Each referral code can be used by up to this many new users
          </p>
        </div>
      )}
    </Feature>
  );
}

export default ReferralFeature;
